export const competitionDirectoryReturn = (location, id) => {
  const path = '/events/' + id + '/competitions'
  const saved = location?.state?.competitionReturnTo
  return saved === path || saved?.startsWith(path + '?') ? saved : path
}
